import { Injectable } from '@angular/core';
//import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';

@Injectable()
export class RuleengineService {

	constructor(private http: HttpClient) { }

	ruleAppSubmit(formVal): Observable<any> {
		return this.http.post(environment.appUrl + "ruleengine/ruleengineSubmit", { formVal: formVal })
			.map(result => {
				return result;
			});
	}

	getRulesManage(accID, projID, searchInp): Observable<any> {
		return this.http.get(environment.appUrl + "ruleengine/getruleengineSubmit", { params: { accountID: accID, projectID: projID, searchInp: searchInp } })
			.map(result => {
				return result;
			});
	}

	getDBOption(accID, projID, collName) {
		/*console.log(accID);
		console.log(projID);
		console.log(collName);*/
		return this.http.get(environment.appUrl + "ruleengine/getOptionDB", { params: { accountID: accID, projectID: projID, collectName: collName } })
			.map(result => {
				return result;
			});
	}


	getRulesById(ruleID): Observable<any> {
		return this.http.get(environment.appUrl + "ruleengine/getruleengineByIdSubmit", { params: { ruleID: ruleID } })
			.map(result => {
				return result;
			});
	}

	deleteRule(fieldName, accID, projID, compObj, ruleID, typeStr): Observable<any> {
		return this.http.post(environment.appUrl + "ruleengine/delruleengineSubmit", { accountID: accID, projectID: projID, fieldName: fieldName, compObj: compObj, ruleID: ruleID, typeStr })
			.map(result => {
				return result;
			});
	}

	getRelaxationList(accID, projID): Observable<any> {
		return this.http.get(environment.appUrl + "ruleengine/getageRelaxationListSubmit", { params: { accountID: accID, projectID: projID } })
			.map(result => {
				return result;
			});
	}

	saveAgeRulesManage(formVal, ID): Observable<any> {
		return this.http.post(environment.appUrl + "ruleengine/addageruleengineSubmit", { formVal: formVal, ID: ID })
			.map(result => {
				return result;
			});
	}
	getAgeCofigDetails(PID: any, AID: any) {
		let PID1 = JSON.stringify(PID);
		let AID1 = JSON.stringify(AID);
		return this.http.get(environment.appUrl + "age", { params: { projectName: PID1, accountName: AID1 } })
			.map(result => {
				return result;
			});

	}
	ageConfigStore(formJSON2: any, PID: any, AID: any, ID: any) {


		let formJSON1 = JSON.stringify(formJSON2);

		let PID1 = JSON.stringify(PID);
		let AID1 = JSON.stringify(AID);
		let ID1 = JSON.stringify(ID);
		let payload = { formJSON: formJSON1, projectName: PID1, accountName: AID1, ID: ID1 };
		console.log("payload is", payload);
		return this.http.post(environment.appUrl + "age", payload)
			.map(result => {
				return result;
			});
	}

	uploadChildData(formData): Observable<any> {
		//var headers = new HttpHeaders();
		//headers.append('Content-Type', 'application/form-data');
		return this.http.post(environment.appUrl + "dependent/saveData", formData)
			.map(result => {
				return result;
			});
	}
	uploadPreferenceData(formData): Observable<any> {
		//var headers = new HttpHeaders();
		//headers.append('Content-Type', 'application/form-data');
		return this.http.post(environment.appUrl + "dependent/saveData", formData)
			.map(result => {
				return result;
			});
	}

	getListData(fldName, projectId): Observable<any> {
		return this.http.post(environment.appUrl + "dependent/getListData", { fldName: fldName, projectId: projectId })
			.map(result => {
				return result;
			});
	}

	dataMapping(formData, projectId, editId): Observable<any> {
		return this.http.post(environment.appUrl + "dependent/dataMapping", { formData: formData, projectId: projectId, editId: editId })
			.map(result => {
				return result;
			});
	}

	vacancyData(formData, projectId): Observable<any> {
		return this.http.post(environment.appUrl + "dependent/dataVacancy", { formData: formData, projectId: projectId })
			.map(result => {
				return result;
			});
	}

	getMappingData(projID, mappingType = 'data'): Observable<any> {
		return this.http.get(environment.appUrl + "dependent/getMapping", { params: { projectID: projID, mappingType } })
			.map(result => {
				return result;
			});
	}

	delVacancy(vacancyId, projID): Observable<any> {
		return this.http.put(environment.appUrl + "dependent/delVacancy", { projectID: projID, vacancyId })
			.map(result => {
				return result;
			});
	}

	getMasterDocument(projID, tblName = ''): Observable<any> {
		return this.http.get(environment.appUrl + "dependent/getMasterDocument", { params: { projectID: projID, tblName } })
			.map(result => {
				return result;
			});
	}

	updatetMasterDocument(projID, updateData, tblName) {
		return this.http.put(environment.appUrl + "dependent/updatetMasterDocument", { projectID: projID, updateData, tblName })
			.map(result => {
				return result;
			});
	}

	delMapping(mapParentId, mapId, projID) {
		return this.http.put(environment.appUrl + "dependent/delMapping", { projectID: projID, mapParentId, mapId })
			.map(result => {
				return result;
			});
	}

	gridCheckStore(formData, projID, accID): Observable<any> {
		console.log("inside service file", formData);


		return this.http.post(environment.appUrl + "ruleengine/saveGridCheckData", { formData, projID, accID })
			.map(result => {
				return result;
			});

	}

	getGridCheckData(projID): Observable<any> {
		console.log("inside  get listservice file");
		return this.http.get(environment.appUrl + "ruleengine/getGridCheckData", { params: { PID: projID } })
			.map(result => {
				return result;
			});

	}

}
